import { render, staticRenderFns } from "./BookingsTable.vue?vue&type=template&id=a882ce1a&scoped=true"
import script from "./BookingsTable.vue?vue&type=script&lang=js"
export * from "./BookingsTable.vue?vue&type=script&lang=js"
import style0 from "./BookingsTable.vue?vue&type=style&index=0&id=a882ce1a&prod&lang=css"
import style1 from "./BookingsTable.vue?vue&type=style&index=1&id=a882ce1a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a882ce1a",
  null
  
)

export default component.exports